import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";

/** Animated number that smoothly tweens from previous to next value with a small scale-pop on change. */
export function CountUp({ value, className = "" }: { value: number; className?: string }) {
  const motionVal = useMotionValue(value);
  const rounded = useTransform(motionVal, (v) => Math.round(v).toString());
  const prev = useRef(value);

  useEffect(() => {
    if (prev.current === value) return;
    const controls = animate(motionVal, value, { duration: 0.7, ease: "easeOut" });
    prev.current = value;
    return controls.stop;
  }, [value, motionVal]);

  return (
    <motion.span
      key={value}
      initial={{ scale: 1.4, color: "hsl(var(--accent))" }}
      animate={{ scale: 1, color: "currentColor" }}
      transition={{ duration: 0.45, ease: "easeOut" }}
      className={`inline-block tabular-nums ${className}`}
    >
      <motion.span>{rounded}</motion.span>
    </motion.span>
  );
}
